exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n.db-page {\n  padding: 10px; }\n\nag-grid-angular {\n  width: 300px;\n  height: 200px;\n  border: 5px #000000 solid; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/db-page/db-page.scss
// module id = ../../../../../src/app/sample/containers/db-page/db-page.scss
// module chunks = main